/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ProxyBidNotificationMailPreference {
  AsConfigured = 'as_configured',
  Collected = 'collected',
  Individual = 'individual',
  None = 'none'
}
